<template>
<w-setting-sliding-popup ref="slidingPopup" :title="popupTitle" width="500px" @open="open" @close="close">
  <div slot="content">
    <el-form :model="rscFormData" label-position="top" :rules="rules" ref="rscForm">
      <el-row>
        <el-form-item label="자원 ID" prop="rscId">
          <el-input v-model="rscFormData.rscId" placeholder="입력해 주세요." :disabled="true"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="자원명" prop="rscName">
          <el-input v-model="rscFormData.rscName" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="자원단위" prop="rscUnit">
          <el-input v-model="rscFormData.rscUnit" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="그룹 통계 구분" prop="groupstatType">
            <el-select v-model="rscFormData.groupstatType" style="width:100%">
              <el-option v-for="item in groupstatTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="자원 수집 결과 형태" prop="rscDatatypeId">
            <el-select v-model="rscFormData.rscDatatypeId" style="width:100%">
              <el-option v-for="item in rscDatatypeList" :key="item.rscDatatypeId" :label="item.rscDatatypeName" :value="item.rscDatatypeId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="이벤트 메시지 포멧" prop="eventMessageFormatId">
            <el-select v-model="rscFormData.eventMessageFormatId" style="width:100%">
              <el-option v-for="item in eventMessageFormatList" :key="item.eventMessageFormatId" :label="item.eventMessageFormatName" :value="item.eventMessageFormatId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
        </el-col>
      </el-row>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" type="solid" class="mr-r4" @click="saveButton">저장</el-button>
    <el-button size="large" @click="cancelButton">취소</el-button>
  </el-row>
</w-setting-sliding-popup>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import msgUtil from '@/utils/message';

export default {
  name: 'WUpdateRscPopup',
  props: {
    managetypeId: String,
    rsctypeId: String,
    updateRow: Object,
  },
  data() {
    return {
      popupTitle: null,
      eventMessageFormatList: [],
      rscDatatypeList: [],
      groupstatTypeList: [],
      rscFormData: {
        rscId: null,
        rscName: null,
        rscUnit: null,
        groupstatType: null,
        rscDatatypeId: null,
        eventMessageFormatId: null,
      },
      rules: {
        rscName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
    };
  },
  methods: {
    open() {
      const managetypeId = this.managetypeId;
      const managetypeKey = this.managetypeKey;
      const updateRow = this.updateRow;
      this.popupTitle = `${updateRow.rscName} 정보`;
      this.rscFormData = updateRow;
      RscSettingsAPI.getEventMessageFormatListByManagetypeId({
        managetypeId,
        managetypeKey,
      }).then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.eventMessageFormatList = cloneDeep(result);
          if (isNil(this.rscFormData.eventMessageFormatId)) {
            this.rscFormData.eventMessageFormatId = cloneDeep(result)[0].eventMessageFormatId;
          }
        }
      });
      RscSettingsAPI.getRscDatatypeList().then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.rscDatatypeList = cloneDeep(result);
          if (isNil(this.rscFormData.rscDatatypeId)) {
            this.rscFormData.rscDatatypeId = cloneDeep(result)[0].rscDatatypeId;
          }
        }
      });
      BasicinfoSubAPI.getList('GROUPSTATTYPE').then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.groupstatTypeList = cloneDeep(result);
          if (isNil(this.rscFormData.groupstatType)) {
            this.rscFormData.groupstatType = cloneDeep(result)[0].basicinfoSubid;
          }
        }
      });
    },
    close() {
      this.$refs.rscForm.resetFields();
    },
    saveButton() {
      const managetypeId = this.managetypeId;
      const rsctypeId = this.rsctypeId;
      const rscFormData = this.rscFormData;
      rscFormData.managetypeId = managetypeId;
      rscFormData.rsctypeId = rsctypeId;
      this.$refs.rscForm
        .validate()
        .then((response) => {
          if (response) {
            const action = msgUtil.action.SAVE;
            const target = '자원';
            RscSettingsAPI.updateRsc(rscFormData)
              .then((res) => {
                if (res.data.success) {
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.$emit('re-load');
                  this.cancelButton();
                } else {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }
              })
              .catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
          }
        })
        .catch(() => {});
    },
    cancelButton() {
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/RscSettings/popup/UpdateRscPopup.vue